import './Avatar.css';

export interface AvatarProps {
  src?: string;
  name: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  status?: 'online' | 'offline' | 'away';
  className?: string;
}

function getInitials(name: string): string {
  return name.split(' ').map(w => w[0]).filter(Boolean).slice(0, 2).join('').toUpperCase();
}

function getColor(name: string): string {
  const colors = ['#6366f1', '#8b5cf6', '#ec4899', '#f43f5e', '#f97316', '#eab308', '#10b981', '#06b6d4', '#3b82f6'];
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  return colors[Math.abs(hash) % colors.length];
}

export function Avatar({ src, name, size = 'md', status, className = '' }: AvatarProps) {
  return (
    <div className={`ui-avatar ui-avatar-${size} ${className}`}>
      {src ? (
        <img src={src} alt={name} className="ui-avatar-img" />
      ) : (
        <div className="ui-avatar-initials" style={{ background: getColor(name) }}>{getInitials(name)}</div>
      )}
      {status && <span className={`ui-avatar-status ui-avatar-${status}`} />}
    </div>
  );
}
